import { useFetchBlastingScenario } from 'app/views/blasting/pages/view-scenario/useFetchBlastingScenario';
import * as v from 'valibot';
import {
  BlastJobStatusSchema,
  ConcentrationDataSchema,
  ConcentrationRegionSchema,
  FlyrockBoundarySchema,
  FlyrockSimulationModelSchema,
  GisTrackDataTimeStepSchema,
  GroundVibrationSimulationModelSchema,
  IPpvThresholdSchema,
  OverlayFileInfoSchema,
  PlumeDataSchema,
} from 'app/business-logic/domain-models/Blasting.schema';

export enum BlastModelType {
  Dispersion = 'dispersion',
  Flyrock = 'flyrock',
  FumeManagementZone = 'fumeManagementZone',
  GroundVibration = 'groundVibration',
  OverpressureContour = 'overpressureContour',
  OverpressureGain = 'overpressureGain',
  Path = 'path',
  Vibration = 'vibration',
}

export enum BlastSetup {
  Burden = 'burden',
  Stemming = 'stemming',
}

export type BlastJobStatus = v.InferOutput<typeof BlastJobStatusSchema>;

export type IBlastScenario = NonNullable<ReturnType<typeof useFetchBlastingScenario>['data']>;

export enum BlastModelCategory {
  Animated = 'animated',
  Snapshot = 'snapshot',
}

export enum BlastSimulationGroupingAttribute {
  Model = 'model',
  Time = 'time',
}

export type IFlyrockSimulationModel = v.InferOutput<typeof FlyrockSimulationModelSchema>;

export type IPlumeData = v.InferOutput<typeof PlumeDataSchema>;

export type IConcentrationData = v.InferOutput<typeof ConcentrationDataSchema>;

export type IConcentrationRegion = v.InferOutput<typeof ConcentrationRegionSchema>;

export type IFlyrockBoundary = v.InferOutput<typeof FlyrockBoundarySchema>;

export type IGroundVibrationSimulationModel = v.InferOutput<typeof GroundVibrationSimulationModelSchema>;

export type IGisTrackDataTimeStep = v.InferOutput<typeof GisTrackDataTimeStepSchema>;

export type IPpvThreshold = v.InferOutput<typeof IPpvThresholdSchema>;

export type OverlayFileInfo = v.InferOutput<typeof OverlayFileInfoSchema>;
